import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import estilos from '../UsuariosAtencionACliente/CuadroAtencionAClienteComponent.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faPlus
} from '@fortawesome/free-solid-svg-icons'
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import { useDispatch, useSelector } from 'react-redux'
import AtencionAClienteFormComponent from '../UsuariosAtencionACliente/AtencionAClienteFormComponent'
import CuadroAtencionAClienteComponent from '../UsuariosAtencionACliente/CuadroAtencionAClienteComponent'
import UsuariosComponent from '../UsuariosAtencionACliente/UsuariosComponent'
import { obtenerCarteras, obtenerUsuariosAtencionACliente } from '../../../redux/DucksAtencionACliente/UsuariosAtencionAClienteDuck'
library.add(faPlus)

function PanelAtencionACliente(props) {
    const dispatch = useDispatch()

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        height: 600,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        'overflowY': 'scroll',
    };

    const usuariosAtencionAClientes = useSelector( store => store.UsuariosAtencionACliente.usuariosAtencionACliente )
    const dataCartera = useSelector(store => store.UsuariosAtencionACliente.dataCartera)

    const [open, setOpen] = React.useState(false);
    const [usuarioModify, setUsuarioModify] = React.useState(null)
    const [carteras, setCarteras] = React.useState(null)

    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setUsuarioModify(null)
        setCarteras(null)
        setOpen(false)
    }

    const handleModify = async (usuario) => {
        handleOpen()
        setUsuarioModify(usuario)
        const carteras = await dispatch(obtenerCarteras())
        setCarteras(carteras.payload)
    }
    React.useEffect(async () => {
        await dispatch(obtenerUsuariosAtencionACliente())        
    }, [])

    return (
        <Fragment><br />
        {/* style={{ maxWidth: 1600, paddingLeft: '10%' }} */}
            <div className='container'>
                <h1 className='text-center tm'>Usuarios de atención a clientes</h1><br />
                <div className={`text-end col-md-12`}>
                    <button className={`btn btn-outline-success btn-sm ${estilos.zoom}`} onClick={handleOpen}>Agregar nuevo usuario</button>
                </div><br /><br />
                {/*  SE RENDERIZAN LAS CREDENCIALES   */}
                {
                    usuariosAtencionAClientes &&
                    <UsuariosComponent usuarios={usuariosAtencionAClientes} dataCartera={dataCartera} onModify={handleModify}/>
                }
                
                {/* <div className='row'>
                    {
                        usuariosAtencionAClientes.map((usuario) => (
                            <CuadroAtencionAClienteComponent onModify={handleModify} usuario={usuario}></CuadroAtencionAClienteComponent>
                        ))
                    }
                </div> */}
                <hr/>
                
            </div>


            <div>
                <Modal
                    aria-labelledby="transition-modal-title"
                    aria-describedby="transition-modal-description"
                    open={open}
                    onClose={handleClose}
                    closeAfterTransition
                    BackdropComponent={Backdrop}
                    BackdropProps={{
                        timeout: 500,
                    }}
                >
                    <Fade in={open}>
                        <Box sx={style}>
                           <AtencionAClienteFormComponent usuarioModify={usuarioModify} onClose={handleClose} carteras={carteras}></AtencionAClienteFormComponent>
                        </Box>
                    </Fade>
                </Modal>
            </div>
        </Fragment>
    );
};


export default withRouter(PanelAtencionACliente)
